import React, { useEffect, useState } from "react";

import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import PropTypes from "prop-types";

const BarChartExit = props => {
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (typeof number == "string") {
      if (number.includes("+")) {
        return (
          "+ " +
          parseFloat(number.replaceAll("+", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
      if (number.includes("-")) {
        return (
          "- " +
          parseFloat(number.replaceAll("-", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        label: "Plan Exit",
        backgroundColor: "#5DB490", //#5061BC
        borderColor: "#FFFFFF",
        borderWidth: 1,
        hoverBorderWidth: 3,
        barPercentage: 0.7,
        hoverBackgroundColor: "#5DB490", //#7C90FD
        hoverBorderColor: "#FFFFFF",
        data: [4194, 641, 111, 197],
        datalabels: {
          anchor: "end",
          align: "top",
          offset: 1,
          color: "#5DB490", //#51E7FE
          formatter: function (value, context) {
            if (value == 0) {
              return "";
            }
            return numberFormat(value, 0);
          },
          font: {
            weight: 'bold',
            size: 14,
          }
        },
      },
      {
        label: "Actual Exit",
        backgroundColor: "#97CDB6", //#3147BA
        borderColor: "#FFFFFF",
        borderWidth: 1,
        hoverBorderWidth: 3,
        barPercentage: 0.7,
        hoverBackgroundColor: "#97CDB6", //#4260FF
        hoverBorderColor: "#FFFFFF",
        data: [4194, 641, 111, 197],
        datalabels: {
          anchor: "end",
          align: "top",
          offset: 1,
          color: "#97CDB6", //#A9AEFF
          formatter: function (value, context) {
            if (value == 0) {
              return "";
            }
            return numberFormat(value, 0);
          },
          font: {
            weight: 'bold',
            size: 14,
          }
        },
      },
    ],
  });
  useEffect(() => {
    let newList = props.modelDeviceList.filter(
      item => item.SUPPLYDEMAND_NAME != "Total"
    );
    let groupData = newList.reduce((group, item) => {
      const { EXIT_SUPPLYDEMAND_ZONE } = item;
      group[EXIT_SUPPLYDEMAND_ZONE] = group[EXIT_SUPPLYDEMAND_ZONE] ?? [];
      group[EXIT_SUPPLYDEMAND_ZONE].push(item);
      return group;
    }, {});
    let newExitList = Object.keys(groupData).map(key => {
      if (groupData[key].length > 1)
        return {
          ...groupData[key][0],
          SUPPLYDEMAND_NAME: groupData[key][0].EXIT_SUPPLYDEMAND_ZONE,
        };
      return { ...groupData[key][0] };
    }).sort((a, b) => (a.EXIT_ROW > b.EXIT_ROW) ? 1 : ((b.EXIT_ROW > a.EXIT_ROW) ? -1 : 0));
    // let labels = newExitList.map(item => item.SUPPLYDEMAND_NAME);
    let labels = newExitList.map(item => item.SUPPLYDEMAND_NAME.indexOf(',') >= 0 ? item.SUPPLYDEMAND_NAME.substring(0, item.SUPPLYDEMAND_NAME.indexOf(',')) : item.SUPPLYDEMAND_NAME);
    let planExitData = newExitList.map(item =>
      item.DEMAND_PLAN_EXIT
    );
    let actualExitData = newExitList.map(item =>
      item.DEMAND_ACTUAL_EXIT
    );
    setData(prev => {
      return {
        ...prev,
        labels: labels,
        datasets: [
          { ...prev.datasets[0], data: planExitData },
          { ...prev.datasets[1], data: actualExitData },
        ],
      };
    });
    // console.log(props.modelDeviceList)
  }, [props.modelDeviceList]);

  const option = {

    maintainAspectRatio: false,
    scales: {
      dataset: [
        {
          barPercentage: 0.4,
        },
      ],
      xAxes: [
        {
          display: true,
          scaleLabel: {
            display: true,
            fontSize: 15,
            labelString: "Supply-Demand",
            fontColor: "#FFFFFF",
            fontStyle: "bold",
          },
          gridLines: {
            display: true,
          },
          ticks: {
            fontColor: "#FFFFFF",
            fontStyle: "bold",
            fontSize: 15,
          },
        },
      ],
      yAxes: [
        {
          display: true,
          scaleLabel: {
            display: true,
            fontSize: 15,
            labelString: "MMscf",
            fontColor: "#FFFFFF",
            position: "left",
            fontStyle: "bold",
          },
          gridLines: {
            display: true,
          },
          ticks: {
            stepSize: 1000,
            fontColor: "#FFFFFF",
            fontStyle: "bold",
            fontSize: 15,
            // max:0,
            min: 0,
            callback: function (label, index, labels) {
              var val = Math.abs(label);
              // if (val >= 1000) {
              //   val = numberFormat(val / 1000, 1) + " K";
              //   if (label < 0) {
              //     val = val * -1;
              //   }
              // } else {
              if (label < 0) {
                val = val * -1;
              }
              val = numberFormat(val, 0);
              // }

              return val;
            },

          },
        },
      ],
    },
    tooltips: {
      enabled: true,
      mode: 'nearest',
      titleFontSize: 20,
      bodyFontSize: 18,
      bodyFontStyle:"bold",
      intersect: false,
      callbacks: {
        label: function (tooltipItem, data) {
          // console.log(tooltipItem);
          // console.log(data);
          // var indice = tooltipItem.index;
          return " " + numberFormat(tooltipItem.yLabel, 0);
        }
      },
    },
    legend: {
      labels: {
        fontColor: "#FFFFFF",
        fontStyle: "bold",
        fontSize: 14,
      },
    },
  };

  return (
    <React.Fragment>
      <Bar data={data} options={option} plugins={[ChartDataLabels]} />
    </React.Fragment>
  );
};
BarChartExit.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
  modelDeviceList: PropTypes.any,
};

export default BarChartExit;
